import React, { useEffect } from 'react';
import * as filestack from 'filestack-js';

export type FSPickerProps = {
  apikey: string;
  pickerOptions: filestack.PickerOptions;
  onUploadDone: (result: filestack.PickerResponse) => void;
};

function FSPicker(props: FSPickerProps) {
  const { apikey, pickerOptions, onUploadDone } = props;

  useEffect(() => {
    const client = filestack.init(apikey);
    const picker = client.picker({
      displayMode: filestack.PickerDisplayMode.inline,
      container: '#fs-picker',
      onUploadDone,
      ...pickerOptions,
    });

    picker.open();

    return () => {
      if (picker) {
        picker.close();
      }
    };
  }, [apikey, pickerOptions, onUploadDone]);

  return <div style={{ height: 500 }} id="fs-picker" />;
}

export default FSPicker;
